import Bugsnag from '@bugsnag/js'
import React from 'react';
import App from 'next/app';
import Head from 'next/head';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement,
  Legend,
  PointElement,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Error from './_error';

import '../css/shared/app.scss';
import '../css/tag-complete.scss';
import '../css/style.scss';
import bugsnagStart from '../utils/bugsnag.js'
import { IS_DEBUG, IS_PRODUCTION_BUILD } from '../utils/env';
import isPartnerHost from '../utils/is-partner-host';
import portalTitle from '../utils/portal-title';

bugsnagStart()

ChartJS.register(BarElement, CategoryScale, Legend, LinearScale, LineElement, PointElement, Tooltip, ChartDataLabels);

const ErrorBoundary = !IS_DEBUG && !IS_PRODUCTION_BUILD
  ? Bugsnag.getPlugin('react').createErrorBoundary(React)
  : React.createElement('div');

function requestHost({ req }) {
  if (req) return req.headers.host;

  return window.location.host;
}

export default function VoizDashboard({ Component, pageProps, partner }) {
  const title = `Voiz - ${portalTitle(partner)}`;

  if (IS_DEBUG) {
    return (
      <>
        <Head>
          <title>{title}</title>
        </Head>
        <Component {...pageProps} partner={partner} />
      </>
    );
  }

  return (
    <ErrorBoundary FallbackComponent={Error}>
      <Head>
        <title>{title}</title>
      </Head>
      <Component {...pageProps} partner={partner} />
    </ErrorBoundary>
  );
}

VoizDashboard.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  const partner = isPartnerHost(requestHost(appContext.ctx));

  return { ...appProps, partner };
};
